const coinsList = require('../static/coins.json')
export const state = () => ({
  coinsWithFaNameList: JSON.parse(JSON.stringify(coinsList)),
  buyDollarPrice: 0,
  sellDollarPrice: 0,
  currency: 'TMN',
  assets: [],
  arzyptoCoins: [],
  selectedCoin: 'BTC',
  coinPrice: 0,
  coins: [],
  chartData: [],
  loading: {
    chart: false,
    usdtPrice: false,
    coinPrice: false,
    watch: false
  },
  trends: [],
  latest: [],
  coin: {},
  gainer: [],
  loser: [],
  assetsComplete: [],
  coinsSearched: [],
  news: []
})

export const mutations = {
  set_data (state, { stateName, childState = null, data }) {
    if (childState) {
      state[stateName][childState] = data
    } else {
      state[stateName] = data
    }
  },
  set_centrifuge (state, { stateName, index, data }) {
    state[stateName][index].price = Number(data)
  }
}

export const actions = {
  async getCoins ({ dispatch, commit }, payload = { limit: 100, offset: 0, baseURL: process.env.FAPI_URL }) {
    await dispatch('axios/get', { url: process.env.FAPI_URL + '/fapi/coins', config: { params: { limit: payload.limit, offset: payload.offset } } }, { root: true })
      .then((resp) => {
        commit('set_data', { stateName: 'coins', data: resp.data.data })
      }).catch((e) => {
        return e
      })
  },
  async getArzyptoCoins (context) {
    await context.dispatch('axios/get', { url: '/fapi/arzyptoCoinList/' }, { root: true })
      .then((resp) => {
        context.commit('set_data', { stateName: 'arzyptoCoins', data: resp.data.data })
      }).catch((e) => {
        return e
      })
  },
  async getDollarPrice (context, baseURL) {
    context.commit('set_data', { stateName: 'loading', childState: 'usdtPrice', data: true })
    const config = {
      baseURL
    }
    await context.dispatch('axios/get', {
      url: '/currency/price/' + context.state.currency,
      config
    }, { root: true })
      .then((resp) => {
        context.commit('set_data', { stateName: 'loading', childState: 'usdtPrice', data: false })
        context.commit('set_data', { stateName: 'sellDollarPrice', data: resp.data.data.usdt_sell_price })
      }).catch((e) => {
        context.commit('set_data', { stateName: 'loading', childState: 'usdtPrice', data: false })
        return e
      })
    await context.dispatch('axios/get', {
      url: '/history/tetherPrice',
      config: { baseURL: process.env.ASYNC_BASE_URL_API }
    }, { root: true })
      .then((resp) => {
        context.commit('set_data', { stateName: 'loading', childState: 'tetherPrice', data: false })
        context.commit('set_data', { stateName: 'buyDollarPrice', data: resp.data.data.close })
      }).catch((e) => {
        context.commit('set_data', { stateName: 'loading', childState: 'tetherPrice', data: false })
        return e
      })
  },
  async getCoinPrice (context, payload) {
    context.commit('set_data', { stateName: 'loading', childState: 'coinPrice', data: true })
    if (payload === this.$var.USDT) {
      return context.commit('set_data', { stateName: 'coinPrice', data: 1 })
    }
    await context.dispatch('axios/get', {
      url: '/application/coin/priceList',
      config: {
        baseURL: process.env.BASE_URL,
        params: { symbols: payload + 'USDT' }
      }
    }, { root: true })
      .then((resp) => {
        context.commit('set_data', { stateName: 'coinPrice', data: +resp.data.data[0].price })
        context.commit('set_data', { stateName: 'loading', childState: 'coinPrice', data: false })
      }).catch((e) => {
        context.commit('set_data', { stateName: 'loading', childState: 'coinPrice', data: false })
        return e
      })
  },
  assetCoins ({ dispatch, commit }) {
    dispatch('axios/get', { url: '/wallets', config: { baseURL: process.env.BASE_URL_ASSET } }, { root: true })
      .then((resp) => {
        commit('set_data', {
          stateName: 'assets',
          data: resp.data.data.wallets
        })
        // await dispatch('axios/get', {
        //   url: window.location.origin + '/fapi/coinsFilter',
        //   config: { params: { symbols: resp.data.data.wallets.toString() } }
        // }, { root: true })
        //   .then((res) => {
        //     commit('set_data', {
        //       stateName: 'assetsComplete',
        //       data: res.data.data
        //     })
        //   }).catch((e) => {
        //     return e
        //   })
      }).catch((e) => {
        return e
      })
  },
  async getChartData ({ commit, dispatch }, { symbol, interval, start }) {
    commit('set_data', { stateName: 'loading', childState: 'chart', data: true })
    await dispatch('axios/get', { url: window.location.origin + '/fapi/coins/chart/' + symbol.toLowerCase(), config: { params: { interval, start, end: new Date().getTime() } } }, { root: true })
      .then((resp) => {
        commit('set_data', { stateName: 'chartData', data: resp.data.data })
        commit('set_data', { stateName: 'loading', childState: 'chart', data: false })
      }).catch((e) => {
        commit('set_data', { stateName: 'loading', childState: 'chart', data: false })
        return e
      })
  },
  async getLoseAndGain ({ commit, dispatch }) {
    await dispatch('axios/get', { url: '/fapi/loserGainer' }, { root: true })
      .then((resp) => {
        const gainer = resp.data.data.filter(i => i.is_gainer === 1)
        // const loser = resp.data.data.filter(i => i.is_loser === 1)
        gainer.sort((a, b) => {
          return b.change_24h - a.change_24h
        })
        // loser.sort((a, b) => {
        //   return b.change_24h - a.change_24h
        // })
        // loser.forEach((i) => {
        //   i.change_24h = +i.change_24h * -1
        // })
        commit('set_data', { stateName: 'gainer', data: gainer })
        // commit('set_data', { stateName: 'loser', data: loser })
      }).catch((e) => {
        return e
      })
  }
}

export const getters = {
  buyDollarPrice (state) {
    return state.buyDollarPrice
  },
  sellDollarPrice (state) {
    return state.sellDollarPrice
  },
  assets (state) {
    return state.assets
  },
  trends (state) {
    return state.trends
  },
  latest (state) {
    return state.latest
  },
  coinsSearched (state) {
    return state.coinsSearched
  },
  coins (state) {
    return state.coins
  },
  coinsState (state) {
    return state
  },
  assetsComplete (state) {
    return state.assetsComplete
  },
  chartData (state) {
    return state.chartData
  },
  loading (state) {
    return state.loading
  },
  gainer (state) {
    return state.gainer
  },
  loser (state) {
    return state.loser
  },
  news (state) {
    return state.news
  },
  getSymbolFaName: state => (symbol) => {
    if (symbol !== undefined) {
      symbol = symbol.toUpperCase()
    } else {
      symbol = 'BTC'
    }
    const c = state.coinsWithFaNameList.find((coin) => {
      return coin.symbol === symbol
    })

    if (c) {
      return c.fa_name
    }

    return symbol
  }
}
